<template>
    <nav class="navbar navbar-expand-lg navbar-dark bg-navi">
        <router-link :to="{ name: 'Start'}" tag="a" class="navbar-brand">
            <img class="d-none d-lg-block" src="../assets/logo.jpg" height="80" alt="">
            <img class="d-lg-none" src="../assets/logo.jpg" height="50" alt="">

        </router-link>
        <span class="navbar-text">
            <div class="d-none d-lg-block">
                <b>CASA AHUED SA DE CV <br> CAH881122l74</b>
            </div>
            <div class="d-lg-none"><b>AUTOFACTURACI&Oacute;N</b></div>
        </span>
        <button class="navbar-toggler" type="button" :class="{ collapsed : collapse }" @click="collapseMenu">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" :class="{ show : collapse }">
            <ul class="navbar-nav mx-auto">
                <li class="nav-item h2 text-white d-none d-lg-block">AUTOFACTURACI&Oacute;N</li>
                <li class="nav-item text-white d-lg-none"><b>CASA AHUED SA DE CV CAH881122l74</b></li>
            </ul>
            <ul class="navbar-nav pull-right">
                <li class="nav-item">
                    <router-link :to="{ name: 'Start'}" tag="a" class="nav-link">
                        <b>INICIO</b>
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link :to="{ name: 'Invoice'}" tag="a" class="nav-link"  :class="{'active': setActiveMenuTienda}" >
                        <b>FACTURAR</b>
                    </router-link>
                </li>
                <li class="nav-item">
                    <a class="nav-link disabled" href="#" tabindex="-1" aria-disabled="true">CONSULTAR</a>
                </li>
            </ul>
        </div>
    </nav>
</template>

<script>
    export default {
        name: 'Navbar',
        data() {
            return {
                expanded: false,
                collapse: false,
                setActiveMenuTienda: false
            }
        },
        mounted() {
            if (this.$route.name == "Tienda") {
                this.setActiveMenuTienda = true;
            } else {
                this.setActiveMenuTienda = false;
            }
        },
        watch: {
            '$route'() {
                if (this.$route.name == "Tienda") {
                    this.setActiveMenuTienda = true;
                } else {
                    this.setActiveMenuTienda = false;
                }
            }
        },
        methods: {
            collapseMenu() {
                this.collapse = !this.collapse;
            },
        }
    }
</script>
<style>
    .navbar-dark .navbar-nav .nav-link:hover,
    .navbar-dark .navbar-nav .nav-link:focus {
        color: #cc6300 !important;
    }
</style>

